"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* global HOSTS */
var env_config_1 = require("./env-config");
var get_vod_api_url_1 = require("./get-vod-api-url");
var site_based_migration_statuses_1 = require("@wix/wix-vod-constants/dist/common/site-based-migration-statuses");
var hosts_1 = require("@wix/wix-vod-constants/dist/env/hosts");
var globalHosts = {};
if (typeof HOSTS !== 'undefined') {
    // eslint-disable-line no-undef
    globalHosts = HOSTS; // eslint-disable-line no-undef
}
var catalogBaseURL = get_vod_api_url_1.getVODApiUrl(globalHosts.catalog);
exports.isSiteBased = function () {
    return global.__MIGRATION_INFO__ &&
        global.__MIGRATION_INFO__.status === site_based_migration_statuses_1.MIGRATION_STATUSES.FINISHED;
};
var withSiteBased = function (catalogBaseURL) {
    if (exports.isSiteBased()) {
        return catalogBaseURL + "/api/v2";
    }
    return catalogBaseURL;
};
global.__vodEnv = new env_config_1.EnvConfig();
exports.hosts = tslib_1.__assign({}, globalHosts, { publicCatalog: catalogBaseURL }, (global.__vodEnv.isTest() && hosts_1.TEST_SERVER_HOSTS), (global.__vodEnv.isProduction() && hosts_1.PRODUCTION_HOSTS), { catalog: withSiteBased(catalogBaseURL) });
//# sourceMappingURL=settings.js.map